import {
  FormControl,
  Text,
  Textarea,
} from '@chakra-ui/react';
import React from 'react';
import {
  Field,
} from 'react-final-form';
import Label from '../../../components/Intake/Label';

const TextAreaField = (
  { name, label, validate, optional, ...rest }: {
    name: string,
    label?: string,
    optional?: boolean,
    validate?: (value: any) => string | undefined,
    [x: string]: any;
  },
) => {
  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <FormControl>
          <Label optional={optional}>{label}</Label>
          <Textarea
            {...input}
            {...rest}
            isInvalid={meta.touched && meta.error}
            errorBorderColor="red.300"
          />
          {meta.touched && meta.error && (
            <Text color="red.300" fontSize="sm" mt={2} px={4}>{meta.error}</Text>
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default TextAreaField;
